import { Directive, ElementRef, inject } from "@angular/core";
import { Config } from "@ionic/angular";

/**
 * Keeps every <ion-content> on the platform-native style (ios on iOS, md on
 * Android), overriding the md style it would otherwise inherit from the modals
 * forced to mode="md" by MdModalController.
 *
 * Inside those modals the header and footer keep inheriting the modal's md
 * style; only the content reverts to the platform mode. On regular pages the
 * content is already platform-native, so this is a no-op there.
 *
 * The mode is read from the global Ionic Config (config.get("mode") resolves to
 * the platform default since no mode override is set in provideIonicAngular) and
 * is set in the constructor (before the web component's connectedCallback reads
 * it). It is applied only when no explicit `mode` is already present, so a single
 * content can still opt out with mode="md"/"ios".
 *
 * It acts on the <ion-content> of the components that list it in their
 * `imports`: a component that shows an <ion-content> imports it.
 */
@Directive({ selector: "ion-content" })
export class PlatformModeContentDirective {
  constructor() {
    const el = inject<ElementRef<HTMLIonContentElement>>(ElementRef);
    const config = inject(Config);

    if (!el.nativeElement.hasAttribute("mode")) {
      const mode = config.get("mode");
      if (mode) {
        el.nativeElement.setAttribute("mode", mode);
      }
    }
  }
}
